import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledWishlistMostLovedProperties = styled.div`
  background-color: ${baseVariables.color.base20};
  margin-top: ${toRem(48)};
  .wishlist-most-loved-properties-container {
    padding-top: ${toRem(24)};
    padding-bottom: ${toRem(24)};
    @media ${baseVariables.mediaQuery.md} {
      padding-top: ${toRem(48)};
      padding-bottom: ${toRem(48)};
    }
  }
  .wmlp__card-wrapper {
    position: relative;
  }

  .wmlp__heart-btn {
    position: absolute;
    top: ${toRem(20)};
    right: ${toRem(20)};
    z-index: 3;
    background-color: rgba(28, 28, 28, 0.5);
    border: none;
    padding: ${toRem(4)};
    cursor: pointer;
    line-height: 0;
    border-radius: ${toRem(4)};
    overflow: visible;
  }

  .glide__slide {
    &:focus-visible {
      outline: ${toRem(2)} solid ${baseVariables.color.base10};
      outline-offset: ${toRem(2)};
      border-radius: ${toRem(4)};
    }
  }
  .glide__arrow--left,
  .glide__arrow--right {
    &:focus-visible {
      outline: ${toRem(2)} solid ${baseVariables.color.base10};
      outline-offset: ${toRem(2)};
      border-radius: ${toRem(4)};
    }
  }
  [data-glide-el='controls[nav]'] button {
    &:focus-visible {
      outline: ${toRem(2)} solid ${baseVariables.color.base10};
      outline-offset: ${toRem(2)};
      border-radius: 50%;
    }
  }
  .glide__slide glide__slide--active {
    width: ${toRem(343)} !important;
  }

  /* Skeleton */
  .wmlp__skeleton {
    width: 100%;
    height: ${toRem(228)};
    border-radius: ${toRem(24)};
  }

  .glide__slide .property-card__img-container,
  .glide__slide .property-card__img-container--img {
    width: 100%;
    height: ${toRem(228)};
  }

  .glide__slide .property-card__img-container {
    overflow: hidden;
  }

  .glide__slide .property-card__img-container--img,
  .glide__slide .property-card__img-container--img img {
    width: 100%;
    height: ${toRem(228)};
    object-fit: cover;
  }
  .rate-container {
    margin-top: ${toRem(8)};
  }
  .property-card__details-container {
    height: ${toRem(208)} !important;
  }
  .star-container{
    padding-top: ${toRem(16)};
  }
`;
